import React from "react";
import img2 from "../Images/pencil.png";
import img3 from "../Images/Vector.png";

const ResultsDataComponent = ({
	handleDelete = () => {},
	handleEdit = () => {},
	title = "",
	data = [],
}) => {
	if (!data.length) {
		return null;
	}

	return (
		<div>
			<h4 className="mb-3">{title}</h4>
			<div className="table-responsive">
				<form>
					<table>
						<thead
							className="rounded-top"
							style={{ backgroundColor: "#cce6ff" }}
						>
							<tr>
								<th
									style={{
										borderTopLeftRadius: "16px",
										width: "5%",
									}}
								>
									<input
										type="checkbox"
										id="vehicle1"
										name="vehicle1"
										value="Bike"
									></input>
								</th>
								<th
									style={{
										width: "5%",
									}}
								>
									Rank
								</th>
								<th
									style={{
										width: "35%",
									}}
									className="name"
								>
									Name
								</th>
								<th
									style={{
										width: "20%",
									}}
								>
									Stream
								</th>
								<th
									style={{
										width: "20%",
									}}
								>
									Percentage
								</th>
								<th
									style={{
										borderTopRightRadius: "16px",
									}}
								/>
							</tr>
						</thead>
						<tbody>
							{data.map((student) => {
								return (
									<tr
										key={student.id}
										style={{
											borderBottom: "1px solid #A4A4A4",
											marginTop: "20px",
											height: "80px",
										}}
									>
										<td>
											<input
												type="checkbox"
												id="vehicle1"
												name="vehicle1"
												value="Bike"
											/>
										</td>
										<td>{student.rank}</td>
										<td className="name">
											<img src={student.image} height={66} alt="" />{" "}
											{student.name}
										</td>
										<td>{student.stream || "-"}</td>
										<td>{student.percentage}%</td>
										<td>
											<button
												style={{
													background: "transparent",
													border: "none",
												}}
												onClick={(e) => {
													e.preventDefault();
													handleEdit(student);
												}}
											>
												<img src={img2} alt="" />
											</button>
											<button
												style={{
													background: "transparent",
													border: "none",
												}}
												onClick={(e) => {
													e.preventDefault();
													handleDelete(student);
												}}
											>
												<img src={img3} alt="" />
											</button>
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</form>
			</div>
		</div>
	);
};

export default ResultsDataComponent;
